import { render } from "./onboarding-preferences.vue?vue&type=template&id=7fb5bd49"
import script from "./onboarding-preferences.vue?vue&type=script&lang=js"
export * from "./onboarding-preferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__